import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from 'primereact/button'
import { Column } from 'primereact/column'

import { PanelContainer } from '../../../../components/Panel'
import { TermOfPayment } from '../../../../data/models'
import { getConfigTranslation } from '../../../../utils/helper/getConfigTranslation'
import {
  isRowSelectable,
  rowClassName,
} from '../../../../utils/helper/isRowSelectable'
import { ConfigurableTable } from '../../../../utils/wrapper'
import { useConfigContext } from '../../../ui-config/context'
import { useInvoiceById } from '../../data'
import {
  AddTermsOfPayment,
  DeleteTermsOfPayment,
  EditTermsOfPayment,
} from './dialogs'

type Props = {
  invoiceId: string
}

export const TermsOfPayments: React.FC<Props> = ({ invoiceId }) => {
  const { data: invoice, isLoading } = useInvoiceById(invoiceId)
  const { t } = useTranslation()
  const { uiConfig: config } = useConfigContext()
  const [isVisibleDeleteDialog, setIsVisibleDeleteDialog] =
    useState<boolean>(false)

  // get items for rejecting or accepting
  const [selectedItems, setSelectedItems] = useState<
    TermOfPayment[] | undefined
  >()

  // header
  // const header = (
  //   <div className="table-header flex justify-content-between flex-wrap align-items-center">
  //     <h3 className="mx-0 my-1">{t('invoice.termsOfPayments.table.title')}</h3>
  //     <div>
  //       <Button
  //         label={t('common.buttons.delete')}
  //         onClick={() => setIsVisibleDeleteDialog(true)}
  //         icon="pi pi-trash"
  //         className="p-button-outlined mr-2 mb-2"
  //         disabled={!selectedItems || !selectedItems.length}
  //         visible={config?.invoice?.deleteTermsOfPayment?.enabled !== false}
  //       />
  //
  //       <DeleteTermsOfPayment
  //         visible={isVisibleDeleteDialog}
  //         setIsVisibleDialog={setIsVisibleDeleteDialog}
  //         selectedItems={selectedItems!}
  //         setSelectedItemsInTable={setSelectedItems}
  //         invoiceId={invoiceId}
  //         // onSubmit={function (): void {
  //         //   throw new Error('Function not implemented.')
  //         // }}
  //       />
  //
  //       <AddTermsOfPayment invoiceId={invoiceId} />
  //     </div>
  //   </div>
  // )

  //  action template
  const actionBodyTemplate = (rowData: any) => {
    return (
      <>
        <div className="flex justify-content-end flex-nowrap">
          <EditTermsOfPayment
            invoiceId={invoiceId}
            id={rowData.Id}
            selectedItems={selectedItems!}
            setSelectedItems={setSelectedItems}
            setIsVisibleDeleteDialog={setIsVisibleDeleteDialog}
          />
        </div>
      </>
    )
  }

  const buttons = (
    <Column key="buttons" body={actionBodyTemplate} align="right"></Column>
  )

  return (
    <PanelContainer
      header={
        getConfigTranslation(config.invoice.termsOfPayment.title) ??
        t('invoice.termsOfPayments.title')
      }
      id="invoice-termsOfPayment"
      visible={config.invoice.termsOfPayment.enabled}
    >
      <ConfigurableTable
        config={config.invoice.termsOfPayment.table}
        data={invoice?.Payload?.TermsOfPayment}
        buttons={buttons}
        checkboxen={false}
        selected={selectedItems}
        setSelected={setSelectedItems}
        isDataSelectable={isRowSelectable}
        rowClassName={rowClassName}
        isLoading={isLoading}
        stateKey=""
      />
    </PanelContainer>
  )
}
